import type { DrillDownContextState } from './types.context'
import { DrillDownContextActionType } from './types.context'

export const setQueryYearAction = (year: string) => ({
  type: DrillDownContextActionType.SET_QUERY_YEAR,
  payload: year,
})

export const setQueryPeriodAction = (period: string) => ({
  type: DrillDownContextActionType.SET_QUERY_PERIOD,
  payload: period,
})

export const SetQuerySearchAction = (search: string) => ({
  type: DrillDownContextActionType.SET_QUERY_SEARCH,
  payload: search,
})

export const setQueryCurrencyAction = (currency: string) => ({
  type: DrillDownContextActionType.SET_QUERY_CURRENCY,
  payload: currency,
})

export const setQueryTypeAction = (type: string) => ({
  type: DrillDownContextActionType.SET_QUERY_TYPE,
  payload: type,
})

export const setQueryTypeIdAction = (typeId: string) => ({
  type: DrillDownContextActionType.SET_QUERY_TYPE_ID,
  payload: typeId,
})

export const setProductCategoryIdAction = (productCategoryId: string) => ({
  type: DrillDownContextActionType.SET_PRODUCT_CATEGORY_ID,
  payload: productCategoryId,
})

export const setProductGroupIdAction = (productGroupId: string) => ({
  type: DrillDownContextActionType.SET_PRODUCT_GROUP_ID,
  payload: productGroupId,
})

export const setProductIdAction = (productId: string) => ({
  type: DrillDownContextActionType.SET_PRODUCT_ID,
  payload: productId,
})

export const setDepartmentIdAction = (departmentId: string) => ({
  type: DrillDownContextActionType.SET_DEPARTMENT_ID,
  payload: departmentId,
})

export const setCostObjectIdAction = (costObjectId: string) => ({
  type: DrillDownContextActionType.SET_COST_OBJECT_ID,
  payload: costObjectId,
})

export const setMultipleDrillDownAction = (payload: {
  [K in keyof Partial<DrillDownContextState>]: DrillDownContextState[K]
}) => ({
  type: DrillDownContextActionType.SET_MULTIPLE_DRILL_DOWN,
  payload,
})
